import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=9a821bcc&scoped=true&"
import script from "./home.ts?vue&type=script&lang=ts&"
export * from "./home.ts?vue&type=script&lang=ts&"
import style0 from "./Home.vue?vue&type=style&index=0&id=9a821bcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a821bcc",
  null
  
)

export default component.exports